/* After theme - minimal progressive enhancement */
(function () {
  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt || main.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
      });
    });
  });

  // Variant selection: map selected options to a variant id
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = JSON.parse(form.dataset.variants || '[]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[data-add-to-cart]');
    var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function selected() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return chosen.every(function (value, i) {
          return value === null || v.options[i] === value;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
      var mainImg = document.querySelector('[data-gallery-main]');
      if (mainImg && match.featured_image && match.featured_image.src) mainImg.src = match.featured_image.src;
    }

    form.addEventListener('change', update);
    update();
  });
})();
